<intelishs-shell-sesion [marca]="marca">
  <router-outlet />
</intelishs-shell-sesion>

<!-- Visor global de archivos, montado UNA vez: el servicio lo abre desde donde sea. Sustituye al
     `intelishs-modal-file-viewer` local, que era un fork de este mismo componente y por eso no
     recibia sus mejoras — entre ellas el alto correcto para cualquier tipo de archivo, que el fork
     resolvia con un `height: 75vh` fijo dentro de un flex y desbordaba el viewport. -->
<intelishs-file-viewer />

<!-- Volver al inicio: UNA sola vez a nivel de app, nunca por pagina. Aparece a partir de 320px de
     scroll, en cualquier ruta.
     Es `position: fixed`, o sea anclado al viewport, asi que le da igual el `overflow: auto` de
     `.app-content` del shell. Sin `target`: el shell crece con su contenido (`min-height: 100vh`,
     no `height`), de modo que quien scrollea es el documento, que es el default del componente. -->
<intelishs-back-to-top />
